"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modifier = void 0;
/**
 * Manipulate a buffer after generating
 *
 * @abstract
 * @category Modifiers
 * @class Modifier
 */
class Modifier {
}
exports.Modifier = Modifier;
//# sourceMappingURL=Modifier.js.map